@if (bidItemData) {
  <div class="map-bid-item-wrapper">
    <app-bid-item-details-wrapper
      [data]="bidItemData"
    [options]="{
      disabled: true,
      showActionsSection: false,
      hideHeading: true,
      showMiniMaps: false,
      mapMode: true
    }"
      />
  </div>
}
